const BACKEND_API_ADDRESS =
  process.env.NODE_ENV === "development"
    ? process.env.REACT_APP_BACKEND_API
    : process.env.REACT_APP_BACKEND_API;

const CMS_ADDRESS =
  process.env.NODE_ENV === "production" ? "https://vico.unibiz.io/admin" : "https://vico.unibiz.io/admin";

// export const BASE_API_DOMAIN = "http://192.168.2.174:3001";
export const BASE_API_DOMAIN = BACKEND_API_ADDRESS;
// export const BASE_API_DOMAIN = "http://150.95.104.169:1443";

// export const BASE_IMG_DOMAIN = "http://192.168.2.174:3001";
export const BASE_IMG_DOMAIN = BACKEND_API_ADDRESS;
// export const BASE_IMG_DOMAIN = "http://150.95.104.169:1443";

export const BASE_CLIENT_CONFIG = {
  // DOMAIN: "https://192.168.2.174:3001",
  DOMAIN: CMS_ADDRESS,
  // DOMAIN: "http://150.95.104.169:1443",
  ROUTE: {
    PRODUCT_DETAIL: "/product/:productSlug",
  },
};
